module.exports = __webpack_public_path__ + "static/limit-23d29930cee8eb7a195b16a46c65a00d.jpg";